export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280
}

export const EMITTER_PROPS = {
  cart: {
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    change: 'cart.change',
    render: 'cart.render'
  },
  product: {
    updateVariant: 'product.update_variant',
    openModalGallery: 'product.open_modal_gallery',
    openModalBackInStock: 'product.open_modal_back_in_stock'
  },
  notice: {
    global: 'notice.global'
  },
  collection: {
    toggleFilters: 'collection.toggle_filters'
  },
  quickAdd: {
    open: 'quick_add.open'
  },
  wishlist: {
    list: 'wishlist.list',
    change: 'wishlist.change',
    open: 'wishlist.open'
  },
  search: {
    updatePagination: 'search.update_pagination'
  },
  cache: {
    cartRender: 'cache.cart_render'
  }
}

export const RECENTLY_CONFIG = {
  cookieName: 'swanndri_recently_viewed',
  cookieSkusName: 'swanndri_recently_viewed_skus',
  expireTime: 60 * 60 * 24 * 7, // set cookie expire time to 7 days
  maxLimit: 10
}

export const GRID_VIEW = {
  small: 2,
  large: 4,
  localStorage: 'collection_grid_view'
}

export const METAOBJECT_PREFIX = 'gid://shopify/Metaobject/'

export const SEARCHSPRING_COLOR_FILTER_FIELD_NAME = 'mfield_additional_details_colour'
export const SEARCHSPRING_SIZE_AU_FILTER_FIELD_NAME = 'ss_instock_sizes'
export const SEARCHSPRING_SIZE_NZ_FILTER_FIELD_NAME = 'ss_instock_sizes_nz'
export const SEARCHSPRING_YOTPO_REVIEW_AVERAGE_FILTER_FIELD_NAME = 'reviews_product_score'

// Shoplift A/B test hypothesis ids (Shoplift dashboard -> API test)
export const HYPOTHESIS_IDS = {
  saleColourSwatches: '01a0a38b-52dd-7512-b3e0-8a3d90b5ded0'
}
